module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2zOKV"))).then(() => parcelRequire('d0iPb'));